module.exports = __webpack_public_path__ + "static/media/MakingPicks.3d46def3.png";


//////////////////
// WEBPACK FOOTER
// ./src/screenshots/MakingPicks.png
// module id = 375
// module chunks = 0